export enum LicenseTypes {
  CustomDate = 1,
  Trial = 2,
}
